import i18next from 'i18next';
/**
 * BcmAppDetails Integration Layer
 * Connects SDK Service to Zustand Store
 */
import { toast } from 'sonner';
import { useBcmAppDetailsStore } from '../../store/bcm-app-details.store.js';

export class BcmAppDetailsIntegration {
    constructor(sdkService) {
        this.service = sdkService; // Might be null/undefined if not ready in SDK yet
    }

    async fetchDetails(applicationId) {
        const store = useBcmAppDetailsStore.getState();
        store.setLoading(true);
        store.setError(null);
        store.setDocuments([]);
        store.setContacts([]);

        try {
            if (!this.service) {
                return { success: true, data: { documents: [], contacts: [] } };
            }
            const response = await this.service.getById(applicationId);
            const details = response?.data || {};
            store.setDocuments(details.documents || []);
            store.setContacts(details.contacts || []);

            return { success: true };
        } catch (error) {
            store.setError(error.message);
            return { success: false, error: error.message };
        } finally {
            store.setLoading(false);
        }
    }

    async addDocument(doc) {
        const store = useBcmAppDetailsStore.getState();
        store.setDocuments([...(store.documents || []), doc]);
        toast.success(i18next.t('integrationToasts:documentAdded', { defaultValue: "Document added" }));
        return { success: true };
    }

    async updateDocument(id, updatedDoc) {
        const store = useBcmAppDetailsStore.getState();
        const newDocs = store.documents.map((d) => d.id === id ? { ...updatedDoc, id } : d);
        store.setDocuments(newDocs);
        toast.success(i18next.t('integrationToasts:documentUpdated', { defaultValue: "Document updated" }));
        return { success: true };
    }

    async deleteDocument(id) {
        const store = useBcmAppDetailsStore.getState();
        const newDocs = store.documents.filter((d) => d.id !== id);
        store.setDocuments(newDocs);
        toast.success(i18next.t('integrationToasts:documentDeleted', { defaultValue: "Document deleted" }));
        return { success: true };
    }

    async addContact(contact) {
        const store = useBcmAppDetailsStore.getState();
        store.setContacts([...(store.contacts || []), contact]);
        toast.success(i18next.t('integrationToasts:contactAdded', { defaultValue: "Contact added" }));
        return { success: true };
    }

    async updateContact(id, updatedContact) {
        const store = useBcmAppDetailsStore.getState();
        const newContacts = store.contacts.map((c) => c.id === id ? { ...updatedContact, id } : c);
        store.setContacts(newContacts);
        toast.success(i18next.t('integrationToasts:contactUpdated', { defaultValue: "Contact updated" }));
        return { success: true };
    }

    async deleteContact(id) {
        const store = useBcmAppDetailsStore.getState();
        const newContacts = store.contacts.filter((c) => c.id !== id);
        store.setContacts(newContacts);
        toast.success(i18next.t('integrationToasts:contactDeleted', { defaultValue: "Contact deleted" }));
        return { success: true };
    }
}
